import { render, staticRenderFns } from "./wangEditorTool.vue?vue&type=template&id=2d5e657e&scoped=true"
import script from "./wangEditorTool.vue?vue&type=script&lang=js"
export * from "./wangEditorTool.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./wangEditorTool.vue?vue&type=style&index=1&id=2d5e657e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5e657e",
  null
  
)

export default component.exports